/*
 * @Author: your name
 * @Date: 2022-02-21 10:04:33
 * @LastEditTime: 2022-10-10 16:30:28
 * @LastEditors: chenting chenting@cqliving.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \share-news-detail-pages\src\main.ts
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import MetaInfo from "@/common/vue-meta-info";
import "./common/mixin";
import "@/common/AddPrototype";
import "./common/index.scss";
import "vant/lib/index.css";
import Videojs from "video.js";
import { getData, time, seeTime } from "@/common/dataCollect";
import "video.js/dist/video-js.css";
import "@vant/touch-emulator";
import VueLoadmore from "vuejs-loadmore";
import "@/assets/font/font.scss";

Vue.use(VueLoadmore);
// 标签 打开app
Vue.config.ignoredElements = ["wx-open-launch-app"];
Vue.prototype.$video = Videojs;
Vue.prototype.$getData = getData;
Vue.prototype.$time = time;
Vue.prototype.$seeTime = seeTime;
import { addWaterMarker } from "@/directive/index";
import VueTouch from "vue-touch";
Vue.use(VueTouch, { name: "v-touch" });
VueTouch.config.swipe = {
  threshold: 100
};
// Vue.use(MetaInfo);
Vue.config.productionTip = false;

// 水印功能
Vue.directive("waterMarker", {
  update(el, binding) {
    addWaterMarker(
      binding.value.text,
      el,
      binding.value.font,
      binding.value.textColor
    );
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
